<template>
  <Select :options="packageOptions" :value="action.value" @changeValue="store.commit(`${storeId}.value`, $event)" placeholder="Package"></Select>
</template>

<script>
export default {
  components: {
    //
  },
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    event() {
      return this.config?.event ?? null
    },
    action() {
      return this.config?.action || {}
    },
    more() {
      return this.config?.more || {}
    },
    packages() {
      return Object.assign({}, this.more.groups || {}, this.more.events?.[this.event]?.packages || {})
    },
    packageOptions() {
      let actions = []
      Object.entries(this.more.events?.[this.event]?.packages || {}).forEach(([id, text]) => {
        actions.push({
          id,
          text
        })
      })
      return actions
    }
  },
  methods: {
    //
  },
  props: {
    config: Object
  }
}
</script>
